import dayjs from "dayjs";

// Shared formatting for the Fashion open/close till screens (v4 boards).

const toNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

// "₹5,230.00", "−₹20.00" — the board uses a true minus sign before the symbol.
export const formatTillMoney = (value, currency = {}, { signed = false } = {}) => {
  const n = toNumber(value);
  const symbol = currency?.currSymbol ?? "₹";
  const right = currency?.symbolRightSide === "Y";
  const digits = Math.abs(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const body = right ? `${digits}${symbol}` : `${symbol}${digits}`;
  if (n < 0) return `−${body}`;
  if (signed && n > 0) return `+${body}`;
  return body;
};

// Plain "5,230.00" for table cells where the column already implies the currency.
export const formatTillAmount = (value) => {
  const n = toNumber(value);
  const digits = Math.abs(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return n < 0 ? `−${digits}` : digits;
};

// Session timestamps are stored as "YYYY-MM-DD HH:mm:ss".
export const parseTillDate = (value) => {
  if (!value) return dayjs();
  const d = dayjs(typeof value === "string" ? value.replace(/-/g, "/") : value);
  return d.isValid() ? d : dayjs();
};

export const formatTillDay = (value) => parseTillDate(value).format("ddd D MMM");

export const tillAmountValue = toNumber;
